module.exports = __webpack_public_path__ + "static/app-interface-hires-aaca269cfdf328d5269a83a7a6969ae5.png";